import React, { createContext, useContext, useState } from 'react';

interface NeedHelpContextType {
  needHelpTargetPath: string | null;
  setNeedHelpTargetPath: (path: string | null) => void;
}

const NeedHelpContext = createContext<NeedHelpContextType | undefined>(
  undefined
);

export const useNeedHelpTarget = () => {
  const ctx = useContext(NeedHelpContext);
  if (!ctx) {
    throw new Error('useNeedHelpTarget must be used within NeedHelpProvider');
  }
  return ctx;
};

export const NeedHelpProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [needHelpTargetPath, setNeedHelpTargetPath] = useState<string | null>(
    null
  );

  return (
    <NeedHelpContext.Provider
      value={{ needHelpTargetPath, setNeedHelpTargetPath }}
    >
      {children}
    </NeedHelpContext.Provider>
  );
};
